import React,{useState,useEffect} from 'react';
import styled from 'styled-components';
import TitleHeader from 'components/presenters/header/TitleHeader';
import GroupProjectMainLayout from 'layouts/group/GroupProjectMainLayout'
import BottomModal from 'components/presenters/modal/BottomModal';

import server from 'server/serverController2';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

// 진행중인 프로젝트 
export default function GrouProjectInfo({match}) {
  const userInfo = useSelector(state => { return state.userInfo}); 
  const history = useHistory();

  const [challengeInfo, setChallengeInfo] = useState({});
  
  //Modal State
  const [visible, setVisible] = useState(false);
  const [dataList, setDataList] = useState([]);

    
  //페이지가 렌더링이 되었을 때 한번 호출
  useEffect(() => {
   server.getRequestData(`groups/projects/${match.params.project_no}`,(res)=>{
    if(res.success === 0)
    {
      return;
    }
    else
    {
      if(res?.data)
      {
        setChallengeInfo(res.data)
      }
    }
   });
  },[]);


  //프로젝트 삭제
  const callBack  = (res) =>{
    if(res.success === 1){
        let groupNo = match.params.group_no;
        let redirectURL = `/group/${groupNo}`;
        history.push(redirectURL);
    }else {
        alert("실패")
    }
  }
  const dataSubmit = () => {
    let data = {};
    server.deleteRequestData(`groups/projects/${match.params.project_no}`,JSON.stringify(data),callBack);
  }


  const deleteRequest = async () => {
    try {
      const resultData = await server.deleteRequestData(`groups/projects/${match.params.project_no}`);
      if(resultData['success'] === 0) {
        return;
      }
      history.replace(`/group/${match.params.group_no}`);
      setVisible(false);
    } catch (error) {
      if(process.env.NODE_ENV === 'development') {
        console.log(error);
      }
    }
  }

  //handleModal
  const handleModalState = () => { 
    if(userInfo['role'] === 'admin' || challengeInfo['group_role'] === "admin") {
      setDataList([
        {type: 'redirect', text: '챌린지 수정', path:`/group/project/${match.params.project_no}/update`},//
        {type: 'callback', text: '챌린지 삭제', callback: deleteRequest, callbackParam: '', style: {color: '#DE0000'}},
      
      ])
    } 
    setVisible(true);
  }

  return(
      <GrouProjectInfoinner>
        <FixedTopNav>
          <DummySpacer></DummySpacer>
          <TitleHeader title={challengeInfo['title']} back={`/`} userInfo={userInfo} isDotBtn={(userInfo['role'] === 'admin' || challengeInfo['group_role'] === "admin")? true: null} handleModalState={handleModalState}/>
        </FixedTopNav>
        <BodyWrapper>
          <GroupProjectMainLayout targetNo={match.params.project_no} type="group" />
          <BottomModal visible={visible} setVisible={setVisible} dataList={dataList}/> 
        </BodyWrapper>
      </GrouProjectInfoinner>
  )
}

const GrouProjectInfoinner = styled.div`
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-flow: column;
`
const FixedTopNav = styled.div`
  flex: 0 1 auto;
`;
const DummySpacer = styled.div`
  height: calc(100vw*(51/375));
`;
const BodyWrapper = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow: hidden;
`
